import { InputAdornment, TextField, TextFieldProps } from "@material-ui/core";
import { useState } from "react";
import { useI18nFieldState } from "../../hooks";
import { I18NLanguagePicker } from "../i18n_language_picker";

export type I18NTextFieldProps<T> = Omit<
  TextFieldProps,
  "value" | "onChange" | "onBlur" | "defaultValue"
> & {
  i18nFieldName: string;
  value: T;
  onChange: (newValue: T) => void;
  forceUpdate?: boolean;
};

export function I18NTextField<T>(props: I18NTextFieldProps<T>) {
  const { value, onChange, i18nFieldName, forceUpdate, ...textFieldProps } =
    props;

  const [selectedLanguage, setSelectedLanguage] = useState<string>("it");
  const { displayedValue, setDisplayedValue, triggerSetValue } =
    useI18nFieldState(i18nFieldName, selectedLanguage, value, onChange);

  return (
    <TextField
      variant="outlined"
      {...textFieldProps}
      value={displayedValue}
      onChange={(evt) => {
        setDisplayedValue(evt.target.value);
        if (forceUpdate) triggerSetValue(evt.target.value);
      }}
      {...(forceUpdate
        ? {}
        : { onBlur: (evt) => triggerSetValue(evt.target.value) })}
      InputProps={{
        ...(textFieldProps?.InputProps ?? {}),
        startAdornment: (
          <InputAdornment position="start">
            <I18NLanguagePicker
              value={selectedLanguage}
              onChange={(value) => setSelectedLanguage(value)}
              className="laguage-picker-select_no-line"
            />
          </InputAdornment>
        ),
      }}
    />
  );
}
